export default __webpack_public_path__ + "static/media/1796.de999e1a.png";